import React from 'react';
import heroBg from '../../../assets/site/bg-mission.jpg';
import Section from '../../site/components/Section';
import cx from '../../site/utils/cx';
import ui from '../../site/styles/primitives.module.css';
import { glance } from '../aboutContent';
import styles from './AboutHero.module.css';

const AboutHero = () => (
  <Section id="top" background={heroBg} backgroundPosition="center 62%" className={styles.hero}>
    <div className={cx(ui.wrap, styles.grid)}>
      <div data-reveal="">
        <span className={ui.eyebrow}>Who we are</span>
        <h1 className={styles.title}>
          About <span className={ui.grad}>DS360 Investment</span>
        </h1>
        <p className={styles.lede}>
          DS360 Investment is a New Jersey-based real estate investment company. We partner with investors to acquire,
          develop and revitalize real estate, creating lasting value for our clients and for the communities we build
          in.
        </p>
        <div className={styles.actions}>
          <a className={cx(ui.btn, ui.btnPrimary)} href="#founder">
            Meet our founder
          </a>
          <a className={cx(ui.btn, ui.btnGhost)} href="#call">
            Schedule a call
          </a>
        </div>
      </div>

      <aside className={cx(styles.glance, ui.glass)} aria-labelledby="about-glance" data-reveal="">
        <h2 id="about-glance">At a glance</h2>
        <dl>
          {glance.map((row) => (
            <div key={row.label} className={styles.row}>
              <dt>{row.label}</dt>
              <dd>{row.value}</dd>
            </div>
          ))}
        </dl>
      </aside>
    </div>
  </Section>
);

export default AboutHero;
